import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators, Dispatch } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { getUserName, getIsLoggedIn } from 'Store/User/selectors';
import { PaymentStatus } from 'Store/Order/enums';
import { fetchClearOrder } from 'Store/Order/thunks';
import { getEventID, getIsOrderItemVoucher, getIsInvalidOrderItem } from 'Components/OrderItem/Redux/selectors';
import OrderHeader from 'Components/OrderHeader/OrderHeader';

import { 
  getOrderID, 
  getPaymentStatus, 
} from 'Store/Order/selectors';

interface IPropsInternal {
  isLoggedIn: boolean;
  userName: string;
  orderID: number;
  currentEventID: number;
  isOrderItemVoucher: boolean;
  isInvalidOrderItem: boolean;
  paymentStatus: PaymentStatus;
  fetchClearOrder: () => void;
}

type Props = IPropsInternal & RouteComponentProps<{}>;

class OrderHeaderContainer extends React.PureComponent<Props> {

  onCancelOrderClick = () => {

    this.props.fetchClearOrder();

    if (this.props.isInvalidOrderItem) {
      this.redirectToStartPage();
      return;
    }

    if (this.props.isOrderItemVoucher) {
      this.redirectToVoucherPage();
    } else {
      this.redirectToEventPage();
    }
  }

  redirectToStartPage = () => {
    this.props.history.replace('/');
  }

  redirectToVoucherPage = () => {
    this.props.history.replace('/order/presentkort');
  }

  redirectToEventPage = () => {
    const { history, currentEventID } = this.props;
    history.replace(`/events/${ currentEventID }`);
  }

  render() {
    return (
      <OrderHeader
        isLoggedIn={ this.props.isLoggedIn }
        userName={ this.props.userName }
        imageUrl='/logo-color.svg'
        isOrderPaid={ this.props.paymentStatus === PaymentStatus.PAID }
        onCancelOrderClick={ this.onCancelOrderClick }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    orderID: getOrderID(state),
    userName: getUserName(state),
    currentEventID: getEventID(state),
    isLoggedIn: getIsLoggedIn(state),
    isOrderItemVoucher: getIsOrderItemVoucher(state),
    isInvalidOrderItem: getIsInvalidOrderItem(state),
    paymentStatus: getPaymentStatus(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchClearOrder,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(OrderHeaderContainer);


// WEBPACK FOOTER //
// ./src/components/OrderHeader/OrderHeaderContainer.tsx